export class WorkHashrateListReq {
    searchWorker: string = ""
    current: number = 1
    workerStatus: string = "0" //1:在线；2：离线；3：失效。0或不传表示全部
    groupId: string = "0"
    size: number = 100
}
